
import {
  INIT_AUTHEN_INFO,

  REQUEST_PING_START,
  REQUEST_PING_SUCCESS,
  REQUEST_PING_FAIL,

  AUTHEN_IDEL,
  AUTHEN_START,
  AUTHEN_SUCCESS,
  AUTHEN_FAIL,

  REQUEST_LOGOUT_START,
  REQUEST_LOGOUT_SUCCESS,
  REQUEST_LOGOUT_FAIL,

} from '../actions/authen'

export const initialState = { error: null, type: INIT_AUTHEN_INFO, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {


    case AUTHEN_IDEL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.req, isLoading: true, type } }
      }

    case AUTHEN_START:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.req, isLoading: true, type } }

      }
    case AUTHEN_SUCCESS:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { user_info: payload.res, isLoading: false, type } }
      }
    case AUTHEN_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_LOGOUT_START:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_LOGOUT_SUCCESS:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload?.res, isLoading: false, type } }
      }

    case REQUEST_LOGOUT_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_PING_START:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_PING_SUCCESS:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload?.res, isLoading: false, type } }
      }

    case REQUEST_PING_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, type, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_AUTHEN_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
